import React, { useEffect, useState } from "react";
import { rankMeta } from "@/lib/ranks";
import { X, PartyPopper } from "lucide-react";

// Shows a one-time celebratory popup whenever the member reaches a new rank.
export default function RankCelebration({ rank }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!rank || rank === "Associate") return;
    if (localStorage.getItem("seen-rank") !== rank) setShow(true);
  }, [rank]);
  if (!show) return null;
  const { color, Icon } = rankMeta(rank);
  const close = () => { localStorage.setItem("seen-rank", rank); setShow(false); };
  return (
    <div className="fixed inset-0 z-[100] grid place-items-center bg-black/70 p-4 backdrop-blur-sm" data-testid="rank-celebration" onClick={close}>
      <div className="relative w-full max-w-sm overflow-hidden rounded-3xl p-8 text-center"
        onClick={(e) => e.stopPropagation()}
        style={{ background: `radial-gradient(120% 120% at 50% 0%, ${color}, #0b0f16)`, border: `1px solid ${color}`, boxShadow: `0 30px 90px -20px ${color}` }}>
        <button onClick={close} className="absolute right-3 top-3 text-white/70 hover:text-white" data-testid="rank-celebration-close"><X size={18} /></button>
        <div className="mx-auto grid h-24 w-24 animate-bounce place-items-center rounded-full" style={{ background: "rgba(0,0,0,0.3)", border: "2px solid rgba(255,255,255,0.55)" }}>
          <Icon size={52} className="text-white" />
        </div>
        <p className="mt-5 flex items-center justify-center gap-2 text-sm font-semibold text-white/85"><PartyPopper size={16} /> Congratulations!</p>
        <h2 className="mt-1 text-3xl font-extrabold text-white" data-testid="rank-celebration-name">{rank} Rank</h2>
        <p className="mt-2 text-sm text-white/80">You've achieved a new rank. Keep building your business to unlock the next milestone!</p>
        <button onClick={close} className="mt-6 w-full rounded-xl bg-white/95 px-4 py-3 text-sm font-bold text-black" data-testid="rank-celebration-continue">Continue</button>
      </div>
    </div>
  );
}
